import classes from './HeaderNavigation.module.css';
import HeaderNavigationItem from '../HeaderNavigationItem/HeaderNavigationItem';
import Dropdown from '../../Components/Dropdown/Dropdown';
import CloseIcon from '@mui/icons-material/Close';
import {useEffect, useState} from 'react';

const HeaderNavigation = ({barClass, closeEvent, items, dropdowns}) => {
	// const items = [
	// 	['Inicio', {}],
	// 	['Nosotros', {}],
	// 	['Contacto', {}],
	// ];

	// const [dropdowns, setDropdowns] = useState([]);

	// useEffect(() => {
	// 	fetch('https://rjknack-server.herokuapp.com/services')
	// 	 	   .then(resp => resp.json())
	// 	 	   .then(data => {
	// 	 	   	setDropdowns([['Servicios Tecnicos', data]]);
	// 	 	   });
	// }, []);

	const capitalizeFirstLetter = string => {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}

	return (
		<div className={classes.container}>
			{
				items.map(([text, link], index) => 
					<HeaderNavigationItem 
					text={capitalizeFirstLetter(text)} 
					link={link} 
					css={capitalizeFirstLetter(text)==="Contacto"?classes.lastItem:""}
					key={index}/>)
			}
			{
				/* 
				[
					[
						[servicios,/servicios],
						[
							[instalacion,/instalacion]
						]
					]
				]
				*/
				dropdowns.map(([header, drops], index) => {
					return <Dropdown 
					sub={capitalizeFirstLetter(header[0])}
					link={header[1]} 
					key={index} 
					items={drops} 
					menuHeight={"40px"} 
					containerCss={classes.dropdownContainer}
					headerHeight={"10px"}/>
				} 
					)
			}
			<div className={`${classes.searchContainer} ${barClass}`}>
				<input/>
				<div onClick={closeEvent}>
					<CloseIcon sx={{
						fontSize:'50px'
					}}/>
				</div>
			</div>
		</div>
	);
};

export default HeaderNavigation;